// WritePost/index.jsx
import React, { useState } from 'react';
import './index.css';

const WritePost = () => {
  // 文章状态
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState('');
  const [tags, setTags] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // 可选的分类
  const categories = [
    '技术分享',
    '生活随笔', 
    '学习笔记',
    '旅行见闻',
    '美食记录',
    '个人思考',
    '资源分享'
  ];
  
  // 快速标签
  const quickTags = [
    { id: 1, name: '技术', color: '#8B5CF6' },
    { id: 2, name: '生活', color: '#7C3AED' },
    { id: 3, name: '学习', color: '#6D28D9' },
    { id: 4, name: '旅行', color: '#5B21B6' },
    { id: 5, name: '美食', color: '#4C1D95' },
    { id: 6, name: '思考', color: '#3730A3' },
    { id: 7, name: '分享', color: '#5E35B1' },
  ];
  
  // 处理快速标签点击
  const handleQuickTagClick = (tagName) => {
    const currentTags = tags.split(',').filter(tag => tag.trim() !== '');
    
    // 如果标签已经存在，则移除
    if (currentTags.includes(tagName)) {
      const updatedTags = currentTags.filter(tag => tag !== tagName);
      setTags(updatedTags.join(', '));
    } else {
      // 否则添加标签
      const updatedTags = [...currentTags, tagName];
      setTags(updatedTags.join(', '));
    }
  };
  
  // 处理提交
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!title.trim()) {
      alert('请输入文章标题');
      return;
    }
    
    if (!category) {
      alert('请选择分类');
      return;
    }
    
    setIsSubmitting(true);
    
    // 模拟提交过程
    setTimeout(() => {
      console.log('提交数据:', {
        title,
        category,
        tags: tags.split(',').map(tag => tag.trim()).filter(tag => tag !== '')
      });
      
      alert('文章已发布！');
      setIsSubmitting(false);
      
      // 重置表单
      setTitle('');
      setCategory('');
      setTags('');
    }, 1500);
  };
  
  // 处理重置
  const handleReset = () => {
    setTitle('');
    setCategory('');
    setTags('');
  };
  
  // 检查标签是否已选中
  const isTagSelected = (tagName) => {
    return tags.split(',').some(tag => tag.trim() === tagName);
  };
  
  return (
    <div className="write-post-container">
      <div className="write-post-header">
        <h1 className="write-post-title">开始你的写作之旅...</h1>
        <p className="write-post-subtitle">分享你的想法、经验和知识</p>
      </div>
      
      <form className="write-post-form" onSubmit={handleSubmit}>
        {/* 标题输入 */}
        <div className="form-group">
          <label htmlFor="title" className="form-label">
            请输入文章标题
            <span className="required">*</span>
          </label>
          <input
            id="title"
            type="text"
            className="form-input"
            placeholder="输入一个吸引人的标题..."
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
          <div className="input-helper">
            标题应该简洁明了，概括文章主要内容
          </div>
        </div>
        
        {/* 分类选择 */}
        <div className="form-group">
          <label htmlFor="category" className="form-label">
            选择分类
            <span className="required">*</span>
          </label>
          <select
            id="category"
            className="form-select"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
          >
            <option value="">请选择分类</option>
            {categories.map((cat, index) => (
              <option key={index} value={cat}>{cat}</option>
            ))}
          </select>
          <div className="input-helper">
            选择一个最适合文章主题的分类
          </div>
        </div>
        
        {/* 标签输入 */}
        <div className="form-group">
          <label htmlFor="tags" className="form-label">
            输入标签：用逗号分隔
          </label>
          <input
            id="tags"
            type="text"
            className="form-input"
            placeholder="例如：React, 前端开发, 教程"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
          />
          <div className="input-helper">
            标签可以帮助读者更好地找到你的文章
          </div>
        </div>
        
        {/* 快速标签 */}
        <div className="form-group">
          <label className="form-label">
            快速标签
          </label>
          <div className="quick-tags-container">
            {quickTags.map(tag => (
              <button
                key={tag.id}
                type="button"
                className={`quick-tag ${isTagSelected(tag.name) ? 'selected' : ''}`}
                style={{ '--tag-color': tag.color }}
                onClick={() => handleQuickTagClick(tag.name)}
              >
                #{tag.name}
                {isTagSelected(tag.name) && (
                  <span className="tag-checkmark">✓</span>
                )}
              </button>
            ))}
          </div>
          <div className="input-helper">
            点击标签可以快速添加或移除
          </div>
        </div>
        
        {/* 表单操作按钮 */}
        <div className="form-actions">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleReset}
            disabled={isSubmitting}
          >
            重置
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="spinner"></span>
                发布中...
              </>
            ) : '发布文章'}
          </button>
        </div>
      </form>
      
      {/* 预览区域 */}
      <div className="preview-section">
        <h3 className="preview-title">文章预览</h3>
        <div className="preview-card">
          <div className="preview-header">
            <div className="preview-category">{category || '未选择分类'}</div>
            <div className="preview-timestamp">刚刚</div>
          </div>
          <h2 className="preview-article-title">
            {title || '你的文章标题将显示在这里'}
          </h2>
          <div className="preview-tags">
            {tags ? (
              tags.split(',').map((tag, index) => (
                tag.trim() && (
                  <span key={index} className="preview-tag">
                    #{tag.trim()}
                  </span>
                )
              ))
            ) : (
              <span className="preview-no-tags">暂无标签</span>
            )}
          </div>
          <div className="preview-content-placeholder">
            {title ? '文章内容预览...' : '填写表单后，这里将显示文章预览'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WritePost;